<template>
  <div id="g-layer" class="right pai-content">
    <div class="main-content-handpick">
      <div class="g-tab-warp-handpick">
        <p class="staggerer-tit">
          {{ title }}
        </p>
        <div
          class="tab-bar-goback"
          @click="goBack"
        />
      </div>
      <side-bar :side-bar-list="sideBarList" />
      <top-nav
        v-if="navList && navList.length > 1"
        :nav-list="navList"
        :current-item="currentTopNav"
      />
      <!-- <sub-nav
          v-if="subNavList && subNavList.length > 0"
          :nav-list="subNavList"
        /> -->
      <router-view v-if="!$route.meta.keepAlive" />
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import SideBar from './SideBar.vue';
import TopNav from './TopNav.vue';
import { getConfigList } from '@api/gp';
import backHandle from '@/utils/core/backHandle';

export default {
  name: 'EditionLayout',
  components: {
    TopNav,
    // SubNav,
    SideBar,
  },
  data() {
    return {
      sideBarList: [],
      title: '',
      id: null,
      // isMSDK,
      // isSlugSDK,
    };
  },
  computed: {
    navList() {
      return  (this.sideBarList.length > 0 && this.sideBarList[this.$store.state.eventCurSideBar]
       && this.sideBarList[this.$store.state.eventCurSideBar].navList) || [];
    },
    // curBar() {
    //   return this.$route.meta.sideBar;
    // },
    // navList() {
    //   return navList.filter((nav) => {
    //     if (nav.onlyMSDK && (!isMSDK || !isSlugSDK)) {
    //       return false;
    //     }
    //     return true;
    //   });
    // },
    // 导航匹配，获取当前激活的一级导航
    currentTopNav() {
      if (!this.navList) return undefined;

      const routerName = this.$route.name;

      return this.navList.find((topNav) => {
        // 一级导航中找到，直接返回
        if (topNav.targetRouterName === routerName) {
          return true;
        }
        return false;

        // const hasChildren = topNav.children && topNav.children.length > 0;
        // if (!hasChildren) return false;
        // // 有子路由的，子路由符合，说明该一级也符合
        // return topNav.children.find(subNav => subNav.targetRouterName === routerName) !== undefined;
      });
    },
    // 二级导航list
    // subNavList() {
    //   if (this.currentTopNav) {
    //     return this.currentTopNav.children || [];
    //   }
    //   return [];
    // },
  },
  created() {
    const queryEventId = this.$route.query.eventId;
    let eventId;
    // 兼容url上有多个eventId参数，取第一个。
    if (typeof(queryEventId) === 'string') {
      eventId = queryEventId;
    } else if (queryEventId instanceof Array) {
      [eventId] = queryEventId;
    }
    this.id = eventId || sessionStorage.getItem('eventId');
    sessionStorage.setItem(
      'eventId',
      this.id,
    );
  },
  mounted() {
    this.getConfigs();
  },
  methods: {
    goBack() {
      window.PTTRun && window.PTTSendReport({
        action: 'btn',
        hottag: 'btn_close_关闭页面按钮',
        fortest4: this.id,
      });
      backHandle('backTogame');
    },
    async getConfigs() {
      if (!this.id) {
        alert('缺少大事件id');
        window.Sentry.captureMessage('配置缺少大事件id');
        return;
      }
      try {
        const { data: config } = await getConfigList(this.id);
        const { tabs } = config;
        for (let index = 0; index < tabs.length; index++) {
          const tab = tabs[index];

          if (this.$route.meta.type === tab.type) {
            this.$store.state.eventCurSideBar = index;
          }
          // 1-精选 2-攻略 3-活动 4-专题
          switch (tab.type) {
            case 1:
              tab.targetTo = 'ativity-edition-handpick';
              tab.icon = 'https://gzhcos.qq.com/gp-ingame/img/nav0_no.png';
              tab.curIcon = 'https://gzhcos.qq.com/gp-ingame/img/nav0_be.png';
              tab.ptt = ['btn', 'selected', '精选tab', this.id];
              break;
            case 2:
              tab.targetTo = 'ativity-edition-strategy';
              tab.icon = 'https://gzhcos.qq.com/gp-ingame/img/nav3_no.png';
              tab.curIcon = 'https://gzhcos.qq.com/gp-ingame/img/nav3_be.png';
              tab.ptt = ['btn', 'strategy', '攻略tab', this.id];
              // tab.navList = [
              //   {
              //     name: '精品攻略',
              //     targetRouterName: 'ativity-edition-strategy',
              //   },
              //   {
              //     name: '玩家攻略',
              //     targetRouterName: 'ativity-edition-short',
              //   },
              // ];
              break;
            case 3:
              tab.targetTo = 'ativity-edition-vote';
              tab.icon = 'https://gzhcos.qq.com/gp-ingame/img/nav4_no.png';
              tab.curIcon = 'https://gzhcos.qq.com/gp-ingame/img/nav4_be.png';

              tab.ptt = ['btn', 'activity', '侧导航活动tab', this.id];
              break;
            case 4:
              tab.targetTo = 'ativity-edition-feature';
              tab.icon = 'https://gzhcos.qq.com/gp-ingame/img/nav2_no.png';
              tab.curIcon = 'https://gzhcos.qq.com/gp-ingame/img/nav2_be.png';
              tab.ptt = ['btn', 'version', '专题tab', this.id];
              break;
          }
        }
        this.sideBarList = tabs;
        this.title = config.name;
        this.$store.state.eventSideBarList = this.sideBarList;
      } catch (error) {
        window.Sentry.captureMessage(`getConfig接口失败topic/basic${JSON.stringify(error)}`);
        // console.log('getConfigList', error);
      }
    },
  },
};
</script>


<style lang="scss" scoped >
@import "@scss/var.scss";
.main-content-handpick {
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
   height: calc(100vh - 0.62rem);
  padding-top: 0.62rem;
}
.tab-bar-goback {
  position: absolute;
  right: 0;
  top: 0;
  align-items: center;
  background-size: cover;

  height: 0.62rem;
  width: 0.85rem;
  background: url(~@img/close_top2.png) no-repeat center/cover;
}
@include min200 {
  .main-content-handpick .tab-bar-goback {
    right: 0.5rem;
  }
}

.g-tab-warp-handpick {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0.62rem;
  background: url(~@img/all_tit.png) no-repeat left bottom;
  background-size: cover;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(255,255,255,0.1);

  .staggerer-tit{
    color: #fff;
    font-size: .28rem;
    text-align: center;
    flex: 1;
    margin-right: .85rem;
    box-sizing: border-box;
    line-height: 0.62rem;
  }


}


</style>
